module.exports = __webpack_public_path__ + "img/image01_sp.240e18fd.jpg";